import type { ScoreDetails, ScoreDetailsV3, ScoreDetailsV4, ScoreFileDetail } from '../types';

export interface PromptAttachmentFlags {
  hasSkill: boolean;
  hasRule: boolean;
  hasAgent: boolean;
}

function scoreDetailsWithFiles(
  scoreDetails: ScoreDetails
): ScoreDetailsV3 | ScoreDetailsV4 | null {
  if (!('v' in scoreDetails)) return null;
  if (scoreDetails.v === 3 || scoreDetails.v === 4) {
    return scoreDetails;
  }
  return null;
}

function fileDetailsFromScore(scoreDetails: ScoreDetails | null | undefined): ScoreFileDetail[] {
  if (!scoreDetails || typeof scoreDetails !== 'object') return [];
  const scored = scoreDetailsWithFiles(scoreDetails);
  return scored?.derived?.file_details ?? [];
}

/** Attachment chips for the prompts list — derived from scored file_details only. */
export function promptAttachmentFlags(
  scoreDetails: ScoreDetails | null | undefined
): PromptAttachmentFlags {
  const files = fileDetailsFromScore(scoreDetails);
  let hasSkill = false;
  let hasRule = false;
  let hasAgent = false;
  for (const file of files) {
    const kind = (file.kind ?? '').toLowerCase();
    if (kind === 'skill') hasSkill = true;
    if (kind === 'rule') hasRule = true;
    if (kind === 'agent') hasAgent = true;
  }
  return { hasSkill, hasRule, hasAgent };
}
